import type { AxiosRequestConfig } from 'axios'
import * as ChatBotType from './type'
import ChatBotApi from './url'
import { api } from '@api'

export default {
  /**
   * 챗봇 시작전 사용율 오버 체크
   */
  chatBotOpening(payload: ChatBotType.ChatBotOpeningPayload) {
    return api.post<ChatBotType.ChatBotOpeningRes>(
      ChatBotApi.FETCH_CHATBOT_OPENING,
      payload
    )
  },
  /**
   * 챗봇과 채팅
   */
  chatBotChattingPost(
    payload: ChatBotType.ChatBotChattingPostPayload,
    config?: AxiosRequestConfig
  ) {
    return api.post<ChatBotType.ChatBotChattingPostRes>(
      ChatBotApi.CREATE_CHAT_BOT_CHATTING_POST,
      payload,
      config
    )
  },
  /**
   * 챗봇과 채팅 종료
   */
  chatBotChattingClose(payload: ChatBotType.ChatBotClosingPayload) {
    return api.put<ChatBotType.ChatBotClosingRes>(
      ChatBotApi.EDIT_CHAT_BOT_CHATTING_CLOSE,
      payload
    )
  },
}
